module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_05_off.005276e9.svg";